import {
  benefitsPdfFonts,
  BenefitsPdfFontWeight,
  benefitsSummaryPdfFileName,
  buildBenefitsSummaryDocument,
} from "./benefitsSummaryPdf";
import { BenefitsSummaryData } from "./benefitsSummary.types";

const toBase64 = (buffer: ArrayBuffer): string => {
  const bytes = new Uint8Array(buffer);
  let binary = "";
  for (let i = 0; i < bytes.length; i += 0x8000) {
    binary += String.fromCharCode(...bytes.subarray(i, i + 0x8000));
  }
  return btoa(binary);
};

const loadFont = async (url: string): Promise<string> => {
  const response = await fetch(url);
  return toBase64(await response.arrayBuffer());
};

const fontFile = (weight: BenefitsPdfFontWeight) => `roboto-${weight}.woff`;

export const downloadBenefitsSummaryPdf = async (
  data: BenefitsSummaryData,
): Promise<void> => {
  // Loaded on demand: pdfmake and the font files are large
  const [pdfMakeModule, regular, medium, bold] = await Promise.all([
    import("pdfmake/build/pdfmake"),
    import("@fontsource/roboto/files/roboto-latin-400-normal.woff"),
    import("@fontsource/roboto/files/roboto-latin-500-normal.woff"),
    import("@fontsource/roboto/files/roboto-latin-700-normal.woff"),
  ]);
  const pdfMake = (pdfMakeModule as any).default ?? pdfMakeModule;

  // Same Roboto files the page loads, so type renders identically
  const [r, m, b] = await Promise.all(
    [regular, medium, bold].map((f) => loadFont((f as any).default ?? f)),
  );
  pdfMake.addVirtualFileSystem({
    [fontFile(400)]: r,
    [fontFile(500)]: m,
    [fontFile(700)]: b,
  });
  pdfMake.setFonts(benefitsPdfFonts(fontFile));

  await pdfMake
    .createPdf(buildBenefitsSummaryDocument(data))
    .download(benefitsSummaryPdfFileName(data));
};
